import { render, staticRenderFns } from "./PcaPlotIcon.vue?vue&type=template&id=2c6dae9b&scoped=true"
import script from "./PcaPlotIcon.vue?vue&type=script&lang=js"
export * from "./PcaPlotIcon.vue?vue&type=script&lang=js"
import style0 from "./PcaPlotIcon.vue?vue&type=style&index=0&id=2c6dae9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6dae9b",
  null
  
)

export default component.exports